import { Action } from "./index";
// import { filteredAgentsList } from './WorkersFilters';

const INCREMENT = "INCREMENT";
const DECREMENT = "DECREMENT";

const initialState: CounterState = {
  value: 0,
};

export interface CounterState {
  value: number;
}

export class CounterActions {
  static increment = (): Action => ({ type: INCREMENT });
  static decrement = (): Action => ({ type: DECREMENT });
}

export function reduce(state: CounterState = initialState, action: Action) {
  switch (action.type) {
    case INCREMENT:
      return { value: state.value + 1 };
    case DECREMENT:
      return { value: state.value - 1 };

    default:
      return state;
  }
}
